import { specFieldIcons } from './specIcons.jsx';

export const SPEC_LOCATION = 'Pan India Supply + Export';
export const SPEC_THICKNESS = 'As per requirement';
export const SPEC_SIZES = 'As per requirement';
export const SPEC_PE_COATING = 'PE Coated Food Grade';

const field = (label, value, iconKey) => ({
  label,
  value,
  icon: specFieldIcons[iconKey],
});

export function buildSpecs({
  type,
  color = 'White / Natural Kraft / Custom Printed',
  coating,
  material,
  gsm = '35 GSM – 120 GSM (Custom Available)',
  usage,
  thickness = SPEC_THICKNESS,
  feature,
  industrialUse,
  sizes = SPEC_SIZES,
  businessType = 'Manufacturer, Exporter, Supplier, Wholesaler',
  location = SPEC_LOCATION,
}) {
  return {
    businessType: field('Business Type', businessType, 'businessType'),
    location: field('Buyer Preferred Location', location, 'location'),
    type: field('Type', type, 'type'),
    color: field('Color', color, 'color'),
    coating: field('Coating', coating, 'coating'),
    material: field('Material', material, 'material'),
    gsm: field('GSM', gsm, 'gsm'),
    usage: field('Usage', usage, 'usage'),
    thickness: field('Thickness', thickness, 'thickness'),
    feature: field('Feature', feature, 'feature'),
    industrialUse: field('Industrial Use', industrialUse, 'industrialUse'),
    sizes: field('Sizes', sizes, 'sizes'),
  };
}
